export const PERMISSION_MANAGEMENT_TITLE = "Permission Management";
export const PERMISSION_MANAGEMENT_DESC =
  "View page access by role. Permissions reflect the current menu configuration (read-only).";

export const PERMISSION_ACCESS_DENIED =
  "Only Cloud Admin users can access Permission Management.";
export const PERMISSION_VIEW_ROLE_HINT =
  "Choose a role to view page access.";
export const PERMISSION_NO_PAGES = "No menu pages found.";
